// extracted by mini-css-extract-plugin
module.exports = {"footNotes":"FootNotes_footNotes__I2gwW","text":"FootNotes_text__MeO0y"};